import { Component, OnInit } from '@angular/core';
import Chart from 'chart.js';
import { AuthService } from 'src/app/core/services/auth/auth.service';
import { User, UserRole } from 'src/app/shared/models/users/user';

@Component({
  selector: 'app-dashboard',
  templateUrl: 'dashboard.component.html'
})
export class DashboardComponent implements OnInit {
  private user: User = null;
  constructor(private auth: AuthService) {
    this.user = this.auth.user;
  }
  ngOnInit(): void {
  }

  isAdminUser() {
    return this.user && this.user.role === UserRole.ADMIN;
  }
  isLawyerUser() {
    return this.user && this.user.role === UserRole.LAWYER;
  }
  isDataEntryUser() {
    return this.user && this.user.role === UserRole.DATA_ENTRY;
  }

}
